import { render, staticRenderFns } from "./agreement-list.vue?vue&type=template&id=2561435b&"
import script from "./agreement-list.vue?vue&type=script&lang=js&"
export * from "./agreement-list.vue?vue&type=script&lang=js&"
import style0 from "./agreement-list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports